module.exports = __webpack_public_path__ + "img/subBanner18.58ce7def.png";